import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output } from '@angular/core';
import {
  AbstractControl,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators } from '@angular/forms';
import { Change, DateService } from '@softline/core';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Product } from '../../data/product';

export interface FormValue {
  validFrom: string;
  newPriceDate: string;
}

export interface FormSubmit {
  value?: FormValue;
  type: 'new' | 'save';
  valid: boolean;
  validFromValid: boolean;
  newPriceValid: boolean;
}

import { DateInputComponent } from '@softline/ui-core/date-input';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'app-header',
  imports: [CommonModule, ReactiveFormsModule,
    DateInputComponent,
    TranslatePipe],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush })
export class HeaderComponent implements OnInit, OnDestroy {
  private subscription?: Subscription;

  @Input() changedProducts: Change<Product>[] = [];

  @Output() validFromChange = new EventEmitter<string>();
  @Output() formSubmit = new EventEmitter<FormSubmit>();
  @Output() valueChange = new EventEmitter<FormValue>();
  @Output() print = new EventEmitter<{ valid_from: string }>();

  readonly formGroup: UntypedFormGroup = new UntypedFormGroup({
    validFrom: new UntypedFormControl(this.dateService.now(), [Validators.required]),
    newPriceDate: new UntypedFormControl(null, [Validators.required]) });

  private get validFromControl(): AbstractControl {
    return this.formGroup.controls['validFrom'];
  }

  private get newPriceControl(): AbstractControl {
    return this.formGroup.controls['newPriceDate'];
  }

  constructor(private dateService: DateService) {}

  ngOnInit(): void {
    this.subscription = this.formGroup.valueChanges.subscribe((value) =>
      this.valueChange.emit(value)
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = undefined;
    }
  }

  onValidFromChange(value: string): void {
    this.validFromChange.emit(value);
  }

  onPrint() {
    this.print.emit({ valid_from: this.validFromControl.value });
  }

  onSubmit(type: 'new' | 'save') {
    const submitEvent: FormSubmit = {
      type,
      valid: this.formGroup.valid,
      validFromValid: this.validFromControl.valid,
      newPriceValid: this.newPriceControl.valid };

    if (this.formGroup.valid) submitEvent.value = this.formGroup.value;

    this.formSubmit.emit(submitEvent);
  }
}
